module.exports = __webpack_public_path__ + "static/media/Kazakhstan - KZ.453d29f7.png";